export default __webpack_public_path__ + "6bea75a05ddad4b49ba268a5926be35e.png";